import { HttpClient, HttpErrorResponse, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PaginationParams, PaginationResponse } from 'src/app/Theme/shared/components/pagination/pagination.interface';
import { PaginationService } from 'src/app/Theme/shared/components/pagination/pagination.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ItemSpecificationService {
  private host = environment.apiUrlHost;
  constructor(private http: HttpClient,
  private paginationService: PaginationService

  ) { }

  public getCfSpecificationsByItem(
    specificationByItem: string, 
    params: PaginationParams = {},
    specSetId?: string
  ): Observable<PaginationResponse<any>> {
    
    // Build URL with both item and itemSpecSet as required by backend
    // Backend pattern: CF_SpecificationByItemAPI/(?P<item>[^/]+)/(?P<itemSpecSet>[^/]+)/?$
    let url = `${this.host}/CF/CF_SpecificationByItemAPI/${specificationByItem}`;
    if (specSetId) {
      url += `/${specSetId}`;
    }
    
    // Use the built URL that includes both item and itemSpecSet
    return this.paginationService.getPaginatedData<any>(
      url, 
      params // Pass params directly, not { searchParams: params }
    );
  }
  public createCfSpecificationsByItem(SpecificationByItemData: any): Observable<any | HttpErrorResponse> {
    return this.http.post<any>(`${this.host}/CF/CF_SpecificationByItemAPI/`, SpecificationByItemData);
  }

  // Function to consume the update ItemSpecification api
  public updateCfSpecificationByItem(Id: any, ItemSpecificationData: any): Observable<any | HttpErrorResponse> {
    return this.http.put<any>(`${this.host}/CF/CF_SpecificationByItemAPI/${Id}/`, ItemSpecificationData);
  }

  // Function to consume the delete item api
  public deleteCfSpecificationByItem(Id: any): Observable<any> {
    return this.http.delete<any>(`${this.host}/CF/CF_SpecificationByItemAPI/${Id}/`)
  }
  /**
   * Combined specifications list for image assignment (Item Specification source).
   * GET /CF/CF_CombinedSpecifications/
   */
  public getCombinedSpecifications(params: PaginationParams = {}): Observable<PaginationResponse<any>> {
    return this.paginationService.getPaginatedData<any>(`${this.host}/CF/CF_CombinedSpecifications/`, params);
  }

  public getCfItemSpecificationSet(query: string,params: PaginationParams = {}): Observable<any> {
    const searchParams: PaginationParams = {
      ...params,
      query1: query  
    }
    return this.paginationService.getPaginatedData<any>(`${this.host}/CF/CF_ItemSpecificationSet/`, searchParams)
  }

    // Function to consume the create ItemSpecification set api
  public createCfItemSpecificationSet(ItemSpecificationData: any): Observable<any | HttpErrorResponse> {
      return this.http.post<any>(`${this.host}/CF/CF_ItemSpecificationSet/`, ItemSpecificationData)
  }
    // Function to consume the delete item api
public deleteCfItemSpecification(ItemSpecificationCode: any): Observable<any> {
  return this.http.delete<any>(`${this.host}/CF/CF_ItemSpecification/${ItemSpecificationCode}`)
}
public deleteCfItemSpecificationSet(ItemSpecificationCode: any): Observable<any> {
  return this.http.delete<any>(`${this.host}/CF/CF_ItemSpecificationSet/${ItemSpecificationCode}`)
}
// Function to consume the retrieve Item Specification by spec set
public getCfItemSpecificationsById(ItemSpecification: string, params: PaginationParams = {}): Observable<any> {
  const searchParams: PaginationParams = {
    ...params,
    ItemSpecification: ItemSpecification
  }
  return this.paginationService.getPaginatedData<any>(`${this.host}/CF/CF_ItemSpecification/${ItemSpecification}/`, searchParams)
}
public updateCfItemSpecification(ItemSpecification: any, ItemSpecificationData: any): Observable<any | HttpErrorResponse> {
  return this.http.put<any>(`${this.host}/CF/CF_ItemSpecification/${ItemSpecification}`, ItemSpecificationData);
}
// Function to consume the retrieve ItemSpecification set
public getCfItemSpecificationById(ItemSpecification: string,params): Observable<any> {
  const searchParams: PaginationParams = {
    ...params,
  }
  return this.paginationService.getPaginatedData<any>(`${this.host}/CF/CF_ItemSpecificationSet/${ItemSpecification}`,searchParams);
}
  // Function to consume the update Item Specification set set api
  public updateCfItemSpecificationSet(ItemSpecification: any, ItemSpecificationData: any): Observable<any | HttpErrorResponse> {
    return this.http.put<any>(`${this.host}/CF/CF_ItemSpecificationSet/${ItemSpecification}`, ItemSpecificationData);
  }
  public createCfItemSpecification(ItemSpecificationData: any): Observable<any | HttpErrorResponse> {
    return this.http.post<any>(`${this.host}/CF/CF_ItemSpecification/`, ItemSpecificationData);
  }
  public downloadFile(): Observable<Blob> {
    return this.http.get(`${this.host}/CF/specification-sets/template/`, {
      responseType: 'blob'
    });
  }

  /**
   * Compact specification set list for filters (id_set, specificationSet ML, publish, public).
   * GET /CF/specification-sets/names/
   * Optional: publish, public (boolean as query); omit both for full admin list.
   */
  public getSpecificationSetNames(
    params: PaginationParams & { publish?: boolean; public?: boolean } = {}
  ): Observable<PaginationResponse<any>> {
    return this.paginationService.getPaginatedData<any>(
      `${this.host}/CF/specification-sets/names/`,
      params
    );
  }

  /**
   * Published catalog: specification sets (publish=true) with nested specifications.
   * GET /CF/specification-sets/published/specifications/
   * Paginated groups: id_set, specificationSet, description, publish, public, specifications[]
   * (each spec may include `distinct_line_values` for customer filters; item-only rows may have
   * `itemSpec` null with `specByItem_pk` and/or `name_en_key`).
   */
  public getPublishedSpecificationSetsWithSpecifications(
    params: PaginationParams = {}
  ): Observable<PaginationResponse<any>> {
    return this.paginationService.getPaginatedData<any>(
      `${this.host}/CF/specification-sets/published/specifications/`,
      params
    );
  }

  /**
   * Items linked to a specification set (paginated like other CF list APIs).
   * GET /CF/spec-sets/<id_set>/items/
   * Optional: visible_set_only, publish_items (backend query flags); search, page, page_size.
   */
  public getSpecSetLinkedItems(
    setId: string,
    params: PaginationParams & {
      search?: string;
      visible_set_only?: boolean;
      publish_items?: boolean;
    } = {}
  ): Observable<PaginationResponse<any>> {
    const q: PaginationParams = {
      page: params.page,
      page_size: params.page_size,
    };
    const s = params.search;
    if (s != null && String(s).trim() !== '') {
      q['search'] = String(s).trim();
    }
    if (params.visible_set_only === true) {
      q['visible_set_only'] = true;
    }
    if (params.publish_items === true) {
      q['publish_items'] = true;
    }
    return this.paginationService.getPaginatedData<any>(
      `${this.host}/CF/spec-sets/${encodeURIComponent(setId)}/items/`,
      q
    );
  }

  /**
   * Upload specification sets import: sends JSON payload to backend.
   * Specifications are nested inside each set. Excel parsing is done in the component before calling this.
   */
  public uploadFile(payload: {
    specification_sets: Array<{
      specificationSet: Record<string, string>;
      description: Record<string, string>;
      public?: boolean;
      publish?: boolean;
      specifications?: Array<{
        sequence?: number;
        name: Record<string, string>;
        formats: Record<string, string>;
      }>;
    }>;
  }): Observable<any | HttpErrorResponse> {
    return this.http.post<any>(`${this.host}/CF/specification-sets/import/`, payload);
  }

  /**
   * Validate specification-sets Excel before JSON import (multipart file only).
   * POST /CF/specification-sets/upload/check/
   */
  public specificationSetsUploadCheck(file: File): Observable<any | HttpErrorResponse> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<any>(`${this.host}/CF/specification-sets/upload/check/`, formData);
  }

  /**
   * Import specification sets Excel after a successful upload/check (bundle format from server template).
   * POST /CF/specification-sets/excel-bundle/import/
   */
  public specificationSetsExcelBundleImport(file: File): Observable<any | HttpErrorResponse> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<any>(`${this.host}/CF/specification-sets/excel-bundle/import/`, formData);
  }

  /**
   * Excel bundle template for specification sets (workbook from server; replaces client-built templates).
   * GET /CF/specification-sets/excel-bundle/template/
   * Optional: lines_only + item_spec_set for the “specification lines only” flow.
   */
  public downloadSpecificationSetsExcelBundleTemplate(options?: {
    linesOnly?: boolean;
    itemSpecSet?: string;
  }): Observable<HttpResponse<Blob>> {
    let params = new HttpParams();
    if (options?.linesOnly === true) {
      params = params.set('lines_only', 'true');
    }
    const id = options?.itemSpecSet?.trim();
    if (id) {
      params = params.set('item_spec_set', id);
    }
    return this.http.get(`${this.host}/CF/specification-sets/excel-bundle/template/`, {
      observe: 'response',
      responseType: 'blob',
      ...(params.keys().length ? { params } : {})
    });
  }

  /**
   * Download Excel template for item specifications import.
   * GET /CF/item-specifications/template/
   */
  public downloadItemSpecificationsTemplate(): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.host}/CF/item-specifications/template/`, {
      observe: 'response',
      responseType: 'blob'
    });
  }

  /**
   * Import item specifications from an Excel file.
   * POST /CF/item-specifications/import/
   */
  public importItemSpecificationsFile(file: File): Observable<any | HttpErrorResponse> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<any>(`${this.host}/CF/item-specifications/import/`, formData);
  }

  /**
   * Total count of products linked to a specification set (GET /CF/spec-sets/{id}/items/).
   * Uses page_size=1 and reads pagination.count when available.
   */
  public getSpecSetLinkedItemsCount(specSetId: string): Observable<number> {
    const params = new HttpParams().set('page', '1').set('page_size', '1');
    return this.http
      .get<any>(`${this.host}/CF/spec-sets/${specSetId}/items/`, { params })
      .pipe(
        map((data: any) => {
          if (data?.pagination?.count != null) {
            return Number(data.pagination.count);
          }
          if (Array.isArray(data)) {
            return data.length;
          }
          if (data?.results != null && data?.pagination?.count != null) {
            return Number(data.pagination.count);
          }
          if (Array.isArray(data?.results)) {
            return data.results.length;
          }
          return 0;
        })
      );
  }
}
